import envDev from "./env.json";
import envProd from "./env.prod.json";

var env = process.env.NODE_ENV;

if (env === "production" || env === `prod`) {
  var Config = envProd;
} else {
  var Config = envProd;
}

export default Config;
